import React, { memo } from 'react';
import { reduxForm } from 'redux-form';
import { func, bool, string } from 'prop-types';
import Radium from 'radium';
import { handleKeyDown } from '@widergy/utilitygo-forms-web/dist/utils/formUtils';
import { required } from '@widergy/web-utils/lib/validate';
import { UTLabel } from '@widergy/energy-ui';

import { message } from 'utils/stringUtils';
import { FIELD_TEXT_AREA } from 'constants/userForms';
import { CLAIMS_CONFIRM_FORM } from 'constants/reduxForms';
import UTForm from 'app/components/UTForm';

import styles from './styles';

const validate = [required(message('Translation:fieldRequired'))];

const ConfirmAlert = ({ placeholder, withComment, name, handleSubmit, message: mssg }) => {
  const fields = [
    {
      id: 1,
      key: name,
      type: FIELD_TEXT_AREA,
      placeholder,
      style: styles.commentArea,
      textAreaError: styles.textAreaError,
      validate
    }
  ];

  return (
    <div style={[styles.container, !withComment && styles.containerNoComment]}>
      <UTLabel style={styles.content}>{mssg}</UTLabel>
      {withComment && (
        <form onKeyDown={handleKeyDown(handleSubmit)} onSubmit={handleSubmit} noValidate>
          <UTForm fields={fields} />
        </form>
      )}
    </div>
  );
};

ConfirmAlert.propTypes = {
  handleSubmit: func.isRequired,
  withComment: bool,
  name: string,
  message: string,
  placeholder: string
};

export default reduxForm({ form: CLAIMS_CONFIRM_FORM })(memo(Radium(ConfirmAlert)));
